import React from "react";
import NavHeightAdjust from "../../../../components/navbar/NavHeightAdjust";
import ListPage from "./components/List/ListPage";

const Customer = () => {
  return (
    <NavHeightAdjust>
      <ListPage />
    </NavHeightAdjust>
  );
};

export default Customer;
